import {useCategoryByRouterId} from 'modules/categories/hooks/useCategoryByRouterId';
import {maxmaService} from 'modules/maxma/service';
import {setIsSelection} from 'modules/products/helpers';
import {ProductListPageProvider} from 'modules/products/providers/ProductListPageProvider';
import {useRouter} from 'next/router';
import React, {useEffect, useMemo} from 'react';
import {findPage} from 'routing/helpers';

export const CategoryThirdLevelPageProvider = () => {
    const router = useRouter();
    const category = useCategoryByRouterId();
    const path = router.query.path;

    const title = useMemo(() => {
        if (setIsSelection(path)) {
            return findPage(path)?.title ?? '';
        }

        if (category) {
            return category.title;
        }

        return '';
    }, [category, path]);

    useEffect(() => {
        maxmaService.viewCatalogPage({
            id: category?.id ?? '',
            title,
            url: window.location.href,
        });
    }, [category, title]);

    return <ProductListPageProvider category={category} />;
};
